import { FirestoreV8Compat } from '../Firebase';
import { PhotoContributionConverter, PhotoContributionData } from '../model/PhotoContribution';


export async function createPhotoContribution(photo: PhotoContributionData) {
  const convertedPhoto = PhotoContributionConverter.toFirestore(photo);
  return FirestoreV8Compat.collection('PhotoContributions').add(convertedPhoto);
}

